module.exports = __webpack_public_path__ + "static/adidasSeven-ce89850c9a4e6634abccbf7bb224536b.jpg";